import { TranslationFunctionType } from '@/common/types';
import { array, object } from 'yup';

export const managersSchema = (t: TranslationFunctionType) =>
  object({
    users: array().typeError(t('error.selectOneUser')),
  });
